import dayjs from 'dayjs'

export const useMyTripStore = defineStore('myTrip', {
  state: () => ({
    data: null,
    booking: null,
    tripinfo: null,
    actions: {},
    activities: [],
    bookingFaq: {},
    whitelabelChain: null,
  }),
  getters: {
    GET_BOOKING_FAQ (state) {
      return state.bookingFaq
    },
  },
  actions: {
    //old mutations
    SET_DATA (data) {
      this.data = data
    },

    SET_TRIPINFO (tripinfo) {
      this.tripinfo = tripinfo
    },

    SET_BOOKING (booking) {
      this.booking = booking
    },

    SET_ACTIONS (actions) {
      this.actions = actions
    },

    SET_ACTIVITIES (activities) {
      this.activities = activities
    },

    SET_BOOKING_FAQ (faq) {
      this.bookingFaq = faq
    },

    SET_WHITELABEL_CHAIN (whitelabelChain) {
      const whitelabelStore = useWhitelabelStore()
      if (typeof whitelabelChain === 'string') {
        const whitelabel = whitelabelChain.toLowerCase()
        whitelabelStore.SET_WHITE_LABEL(whitelabel)
        this.whitelabelChain = whitelabel
        return
      }
      this.whitelabelChain = null
    },

    RESET_BOOKING () {
      this.data = null
      this.booking = null
      this.actions = {}
    },

    //old actions
    async getReservation ({ reference, customerId }) {
      const localeStore = useLocaleStore()
      const locale = localeStore.locale

      const { data: result } = await apiFetch(`/${locale}/getreservation/${reference}/${customerId}`)
      result.booking.info.value = toUnixNewlines(result.booking.info.value)
      this.SET_WHITELABEL_CHAIN(result.booking?.contact?.chain)
      this.SET_DATA(result.data)
      this.SET_BOOKING(result.booking)
      this.SET_ACTIONS(result.avalible_actions)

      return result
    },

    async updateReservation ({ reference, customerId, params, key, id, value, name }) {
      const localeStore = useLocaleStore()
      const locale = localeStore.locale

      // ISO Format date for backend
      if (['pax_passport_expires', 'pax_passport_issued', 'pax_dob'].includes(key ?? params.key)) {
        const { localeDateCustomFormats } = useDate()
        value = dayjs(`${params.value ?? value}:05`, localeDateCustomFormats.value.short + ':HH').toISOString().split('T')[0]

        if (params) {
          params.value = value
        }
      }

      const { data: result } = await apiFetch(`/${locale}/updatereservation/${reference}/${customerId}`, {
        method: 'POST',
        body: params || {
          key,
          id,
          value,
          name,
        },
      })

      this.SET_DATA(result.data)
      this.SET_BOOKING(result.booking)
      this.SET_ACTIONS(result.avalible_actions)

      return result
    },

    async getActivities ({ reference, customerId }) {
      const localeStore = useLocaleStore()
      const locale = localeStore.locale

      const { data: activities } = await apiFetch(`/${locale}/rolfevents/list/${reference}/${customerId}`)

      this.SET_ACTIVITIES(activities)

      return activities
    },

    async bookActivity ({ reference, activityId: eventId, numberOfPax, customerId }) {
      const localeStore = useLocaleStore()
      const locale = localeStore.locale

      try {
        await apiFetch(`/${locale}/rolfevents/register`, {
          method: 'POST',
          body: {
            ocr: reference,
            event_id: eventId,
            number_of_pax: numberOfPax,
          },
        })
      } catch {
        //do nothing
      }

      if (customerId) {
        await this.getActivities({ reference, customerId })
      }
    },

    async unbookActivity ({ reference, activityId: eventId, customerId }) {
      const localeStore = useLocaleStore()
      const locale = localeStore.locale

      try {
        await apiFetch(`/${locale}/rolfevents/unregister`, {
          method: 'POST',
          body: {
            ocr: reference,
            event_id: eventId,
          },
        })
      } catch {
        //do nothing
      }

      if (customerId) {
        await this.getActivities({ reference, customerId })
      }
    },

    async getBookingFaq (ocr) {
      const localeStore = useLocaleStore()
      const locale = localeStore.locale

      const { data: faq } = await apiFetch(`/${locale}/booking-faq/${ocr}`)

      this.SET_BOOKING_FAQ(faq)

      return faq
    },

    async fetchInstallmentPaymentLink (ocr, customerId, price) {
      const localeStore = useLocaleStore()
      const locale = localeStore.locale

      const { data: res } = await apiFetch(`/${locale}/generate-customerinfo-installment-payment/${ocr}/${customerId}/${price}`, {
        method: 'GET',
      })

      return res
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useMyTripStore, import.meta.hot))
}
